import {Styles} from "../Styles";
import React from "react";

export const HeaderTextDescription = () => {
	return <Styles.TitleBlock>
		<Styles.Eyebrow>Squad Tactical Overview</Styles.Eyebrow>
		<Styles.Title>Squad Control</Styles.Title>
		<Styles.Subtitle>
			Spieler können Squads beitreten, ihren eigenen Einsatzstatus melden
			und nur innerhalb ihres Squads Ziele abhaken.
		</Styles.Subtitle>
	</Styles.TitleBlock>
}